header();

function header() {
    const BODY = document.body
    const HEADER = document.querySelector(".header");
    const MAIN = document.querySelector(".main");
    const TESTDRIVE_ROW = document.querySelector(".testdrive-row");

    if (!HEADER) return;
    if (!MAIN) return;

    // Адаптивное перемещение строки тест-драйва ======================================================================================================

    moveTestDrive();
    window.addEventListener("resize", moveTestDrive);

    function moveTestDrive() {
        if (window.innerWidth < 575.98) {
            TESTDRIVE_ROW.remove()
            MAIN.prepend(TESTDRIVE_ROW)
        } else {
            if (!TESTDRIVE_ROW.closest('.main')) return
            TESTDRIVE_ROW.remove()
            BODY.prepend(TESTDRIVE_ROW)
        }
    }

    // Внутренний отступ мэйна, равный хэдеру ======================================================================================================

    fixHeader();
    window.addEventListener("resize", fixHeader);
    window.addEventListener("scroll", fixHeader);

    function fixHeader() {
        if (!TESTDRIVE_ROW) return;
        const newPageYOffset = window.pageYOffset;
        const testDriveHeightInBody = window.innerWidth < 575.98 ? 0 : TESTDRIVE_ROW.offsetHeight

        if (newPageYOffset >= testDriveHeightInBody) {
            HEADER.classList.add("header--fixed");
            MAIN.style.paddingTop = HEADER.offsetHeight + "px";
        } else {
            HEADER.classList.remove("header--fixed");
            MAIN.style.paddingTop = 0;
        }
    }

    // Появление хэдера при скролле ======================================================================================================

    let lastPageYOffset = window.pageYOffset;

    toggleHeader();
    window.addEventListener("scroll", toggleHeader);

    function toggleHeader() {
        const newPageYOffset = window.pageYOffset;

        if (newPageYOffset < TESTDRIVE_ROW.offsetHeight + HEADER.offsetHeight) {
            HEADER.classList.add("header--show");
            if(!document.querySelector('.modal').classList.contains('modal--is-open'))
            HEADER.classList.add("header--border-hidden");
            return false;
        }

        if (newPageYOffset < lastPageYOffset) {
            HEADER.classList.add("header--show");
        } else {
            HEADER.classList.remove("header--show");
            HEADER.classList.remove("header--border-hidden");
        }

        lastPageYOffset = newPageYOffset;
    }
}
